export abstract class ValidationInfo {
    fieldName: string;
    fieldDisplayName: string;

    constructor(name, display) {
        this.fieldName = name;
        this.fieldDisplayName = display;
    }

    abstract get errorMessage(): string;
}

export class RequiredFieldValidation extends ValidationInfo {

    override get errorMessage(): string {
        return `${this.fieldDisplayName} is required`;
    }
}
